import React, { useState } from 'react';
import { Box, Container, useTheme, useMediaQuery, Typography } from '@mui/material';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import CheckerAmendmentTable from '../components/CheckerAmendmentTable';
interface CheckerInboxProps {
  onLogout: () => void;
}
export const CheckerInboxAmendment: React.FC<CheckerInboxProps> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC'
  }} data-id="element-1371">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} data-id="element-1372" />

      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="checker-amendments" data-id="element-1373" />

      <Box component="main" sx={{
      flexGrow: 1,
      p: {
        xs: 2,
        md: 3
      },
      width: {
        sm: `calc(100% - 240px)`
      },
      ml: 0,
      mt: 8
    }} data-id="element-1374">
        <Container maxWidth="xl" disableGutters={isMobile} data-id="element-1375">
          <Box sx={{
          mb: 3
        }} data-id="element-1376">
            <Box sx={{
            width: 42,
            height: 42,
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#0052CC'
          }} data-id="element-1377">
              <Icon icon="lucide:inbox" width={22} height={22} color="white" data-id="element-1378" />
            </Box>
            <Typography variant="h5" fontWeight={700} color="#1F2937" data-id="element-1379">
              Checker Inbox - Amendments
            </Typography>
          </Box>
          <Typography variant="body1" color="text.secondary" data-id="element-1380">
            Review and approve or reject transaction amendment requests.
          </Typography>
        </Container>
      </Box>
    </Box>;
};
export default CheckerInboxAmendment;